import IMG_VISION from "/images/vision.png"
import IMG_MISSION from "/images/mission.png"
import IMG_OBJ from "/images/objectives.png"
import IMG_IMAGINE from "/images/reimagine.png"
import IMG_GLOBE from "/images/globe.png"
import IMG_TRANSFORM from "/images/transform.png"
const Objectives = () => {
  return (
     <section name="objectives" className="font-montserrat bg-light-gray px-4 lg:px-0 py-6 lg:py-12 flex flex-col items-center">
      <h1 className="text-black font-semibold text-2xl  lg:text-3xl text-center mb-4 lg:mb-6">Our Vision, Mission, and Objectives</h1>
      <div className="lg:w-8/12 flex flex-col gap-4 lg:gap-8">

     <div className="grid lg:grid-cols-2 gap-4 lg:gap-8 text-sm lg:text-base ">
      <div className="flex flex-col gap-2 items-center text-center bg-white rounded-lg shadow-md px-4 lg:px-8 py-6">
        <img className=" w-12 lg:w-13" src={IMG_VISION} />
        <h2 className="font-semibold text-lg">Vision</h2>
        <p>To become the national hub that connects social workers to meaningful roles beyond clinical and direct care practice, expanding their impact and reshaping how the profession influences systems, policy, and communities.</p>
      </div>

       <div className="flex flex-col gap-2 items-center text-center bg-white rounded-lg shadow-md px-4 lg:px-8 py-6">
        <img className="w-11 lg:w-13" src={IMG_MISSION} />
         <h2 className="font-semibold text-lg">Mission</h2>
        <p>Provide social workers with career support services that expand access to roles beyond clinical and direct care practice and strengthen their ability to succeed in systems-level positions.</p>
      </div>
     </div>

     <div className="flex text-sm lg:text-base flex-col gap-2 items-center bg-white rounded-lg shadow-md px-4 lg:px-8 py-6">
       <img className="w-10 lg:w-12" src={IMG_OBJ} />
         <h2 className="font-semibold text-lg">Our Objectives</h2>

         <div className=" flex items-center gap-2 lg:gap-4 mb-1">
           <img className="w-10 -ml-1" src={IMG_IMAGINE} />
           <p>Reimagine the Pathways of Practice: Challenge the Micro Pipeline in Social Work (MPISW) by redefining what it means to be a social worker — expanding awareness, visibility, and legitimacy of macro-level roles across education, employment, and leadership.</p>
         </div>

          <div className="flex items-center gap-3 lg:gap-5 mb-1">
           <img className="w-8" src={IMG_GLOBE} />
           <p>Expand the Scope of Social Work Practice: Empower social workers to innovate across systems, industries, and communities — redefining how the profession creates change beyond traditional boundaries.</p>
         </div>

          <div className=" flex items-center gap-3 lg:gap-5 ">
           <img className="w-8" src={IMG_TRANSFORM} />
           <p>Drive Structural and Cultural Transformation: Advance equity and sustainability in the profession by collecting data, amplifying diverse voices, and influencing how schools, agencies, and institutions prepare future social workers for systems-level impact.</p>
         </div>
       
      </div>
     
      </div>
      </section>
  )
}

export default Objectives
